<template>
	<TheHeader></TheHeader>
	
	<div class="container-fluid">
		<div class="container">
			<form name="form">
				<div class="contain row">
					<TheSidebar></TheSidebar>
					
					<ThePageLoading v-if="isPageLoading"></ThePageLoading>
					
					<div class="page-container card col-md-8" v-if="!isPageLoading">
						<ThePageHeader @delete-event="openDeleteDialog" @import-event="importFile" @export-event="exportFile" :renderDelete="(!isViewer && companyReport.status != '' ? true : false)" :renderImport="(!isViewer && companyReport.status == 'Created' ? true : false)" importTooltip="Import Manual Input Cells" :renderExport="(!isViewer && companyReport.status != '' ? true : false)" exportTooltip="Export Manual Input Cells" :isDeleting="isDeleting" :isImporting="isImporting" :isExporting="isExporting"></ThePageHeader>
						
						<div class="row" v-if="pageError == ''">
							<div class="col-md-12 p-4">
								<div class="row mb-3" v-if="identifier != null">
									<div class="col-md-3 required">
										<label class="col-form-label-title">File ID:</label>
									</div>

									<div class="col-md-6">
										<InputText v-model="companyReport.fileId" disabled />
									</div>
								</div>

								<div class="row mb-3">
									<div class="col-md-3 required">
										<label class="col-form-label-title">Conso Group:</label>
									</div>
									<div class="col-md-6">
										<Dropdown :options="consoGroups" optionLabel="name" optionValue="identifier" filter :filterFields="['name']" showClear :placeholder="isConsoGroupLoading ? ('Loading...') : '-- Please Select --'" :loading="isConsoGroupLoading" v-model="companyReport.consoGroup.identifier" :disabled="identifier != null" @change="onConsoGroupChange"></Dropdown>
									</div>
								</div>
								
								<div class="row mb-3">
									<div class="col-md-3 required">
										<label class="col-form-label-title">Balance Sheet Date:</label>
									</div>
									
									<div class="col-md-6">
										<Calendar dateFormat="yy-mm-dd" :manualInput="true" placeholder="Balance Sheet Date" v-model="companyReport.balanceSheetDate" :disabled="identifier != null" />
									</div>
								</div>
								
								<div class="row mb-3">
									<div class="col-md-3 required">
										<label class="col-form-label-title">Currency:</label>
									</div>
									
									<div class="col-md-6">
										<Dropdown :options="currencies" optionLabel="code" optionValue="identifier" filter :filterFields="['code', 'name']" showClear placeholder="-- Please Select --" v-model="companyReport.currency.identifier" :disabled="identifier != null">
											<template #value="slotProps">
												<div v-if="slotProps.value" class="d-flex align-items-center">
													<span class="col-md-3">{{ filterCurrencyCodeByValue(slotProps.value) }}</span>
													<span class="col-md-9">{{ filterCurrencyNameByValue(slotProps.value) }}</span>
												</div>
												<span v-else>
													{{ slotProps.placeholder }}
												</span>
											</template>
											
											<template #option="slotProps">
												<div class="d-flex align-items-center col-md-12">
													<span class="col-md-3">{{ slotProps.option.code }}</span>
													<span class="col-md-9">{{ slotProps.option.name }}</span>
												</div>
											</template>
										</Dropdown>
									</div>
								</div>

								<div class="row mb-3" v-if="identifier != null">
									<div class="col-md-12">
										<Divider type="solid"></Divider>
									</div>
								</div>

								<div v-if="identifier != null">
									<div class="row mb-3">
										<div class="col-md-3">
											<label class="col-form-label-title">Created By:</label>
										</div>

										<div class="col-md-3">
											<InputText class="p-inputtext" type="text" maxlength="50" v-model="companyReport.createdBy" readonly />
										</div>

										<div class="col-md-3">
											<label class="col-form-label-title">Created Date:</label>
										</div>

										<div class="col-md-3" >
											<InputText class="p-inputtext" type="text" maxlength="50" v-model="companyReport.createdDate" readonly />
										</div>
									</div>

									<div class="row mb-3">
										<div class="col-md-3">
											<label class="col-form-label-title">Finalised By:</label>
										</div>

										<div class="col-md-3">
											<InputText class="p-inputtext" type="text" maxlength="50" v-model="companyReport.submissionBy" readonly />
										</div>

										<div class="col-md-3">
											<label class="col-form-label-title">Finalised Date:</label>
										</div>

										<div class="col-md-3" >
											<InputText class="p-inputtext" type="text" maxlength="50" v-model="companyReport.submissionDate" readonly />
										</div>
									</div>

									<div class="row mb-3">
										<div class="col-md-3">
											<label class="col-form-label-title">Status:</label>
										</div>

										<div class="col-md-3" style="padding: 0.5rem 1rem;">
											<Badge class="mr-2" :class="[companyReport.status == 'Accepted' || companyReport.status == 'Finalised' ? 'p-badge-success' : (companyReport.status == 'Rejected' || companyReport.status == 'Cancelled' ? 'p-badge-danger' : (companyReport.status == 'Submitted' ? 'p-badge-primary' : 'p-badge-warning'))]" :value="companyReport.status"></Badge>
										</div>

										<div class="col-md-3">
											<label class="col-form-label-title">Template Version:</label>
										</div>

										<div class="col-md-3">
											<InputText class="p-inputtext" type="text" maxlength="50" v-model="companyReport.templateVersion" readonly />
										</div>
									</div>		
								</div>
								
								<div class="row mb-3">
									<div class="col-md-3"></div>
									
									<div class="d-flex col-md-6">
										<Button class="p-button-sm" :disabled="v$.companyReport.$invalid || isLoading || (identifier != null && companyReport.status != 'Created')" @click="save()" label="Save" v-if="identifier == null" />
										<span class="p-1" v-if="identifier != null" ></span>
										<Button class="p-button-sm" :disabled="v$.companyReport.$invalid || isLoading || isImporting || isExporting || isDeleting || (identifier != null && companyReport.status != 'Created')" :hidden="isViewer" @click="submit" label="Finalise" v-if="identifier != null"/>
										<span class="p-1"></span>
										<Button class="p-button-sm" :disabled="v$.companyReport.$invalid || isLoading || isImporting || isExporting || isDeleting || (identifier != null && companyReport.status != 'Finalised')" :hidden="isViewer" @click="unfinalise" label="Unfinalise" v-if="identifier != null && (!isAdminPortal && (isAdmin || isHQStaff))"/>
										<span class="p-1"></span>
										<Button class="p-button-sm p-button-secondary" @click="cancel" label="Cancel" />
										<span class="p-1"></span>
										
										<TheLoading v-if="isLoading"></TheLoading>
									</div>
									
									<div class="d-flex col-md-3" v-if="identifier != null">
										<Button class="p-button-sm" :label="'Configuration'" @click="showDetailDialog" :disabled="isLoading" />
									</div>
								</div>
							</div>
						</div>
												
						<div class="row mb-3" v-if="identifier != null && isCWKLoaded">
							<div class="col-md-12">
								<InlineMessage severity="info" class="d-block">CWK is currenly loaded in a CWK: {{ loadedInFileId }}</InlineMessage>
							</div>
						</div>

						<div class="row mb-3" v-if="identifier != null && staleChildren.length > 0">
							<div class="col-md-12">
								<InlineMessage v-for="(detail, index) in staleChildren" :key="index" severity="warn" class="d-block mb-2">
									{{ detail.referenceCode }} - {{ detail.referenceName }} ({{ detail.referenceFileId }}) was loaded on {{ detail.lastModifiedDate }}, before it was finalised on {{ detail.referenceSubmissionDate }}. Its data may have changed - please reload.
								</InlineMessage>
							</div>
						</div>

						<TheSheetsDialog :identifier="dialog.identifier" :name="dialog.consoGroupName" :type="'cwk'" :balanceSheetDate="dialog.balanceSheetDate == null ? null : formatToDate(dialog.balanceSheetDate)" :currencyCode="dialog.currencyCode" :id="dialog.id" :templateIndex="dialog.templateIndex" :status="dialog.status" :visible="dialog.visible" :loading="dialog.loading" :isUnsaved="dialog.isUnsaved" :reportSheets="dialog.companyReportSheets" @save="updateSheets" @autoSave="updateSheetCached" @deleteCached="deleteSheetCached" @cancel="closeDialog"></TheSheetsDialog>
						
						<ThePageError @back-event="cancel" :pageError="pageError" v-if="pageError != ''"></ThePageError>
					</div>
					
					<TheFooter></TheFooter>
				</div>
			</form>
		</div>
	</div>
	
	<Dialog v-model:visible="isCalculating" header="Calculating" modal :style="{ width: '40vw' }" :closable="false">
		<p>
			The system is calculating, please do not refresh the page or close the window while calculating.
		</p>
									
		<template #footer>
			<TheLoading v-if="isCalculating"></TheLoading>
		</template>
	</Dialog>
	<Dialog v-model:visible="isDeleteConfirmation" header="Confirmation to delete" modal :style="{ width: '30vw' }">
        <p>
			<spam v-if="isEmptyCWK">
				Are you sure want to delete this CWK?
			</spam>
			<spam v-if="!isEmptyCWK">
				Unable to delete. Unload all items or restructure before deleting.
			</spam>
		</p>
            
		<template #footer>
			<Button label="No" icon="pi pi-times" @click="isDeleteConfirmation=false;" class="p-button-text" />
			<Button v-if="isEmptyCWK" label="Yes" icon="pi pi-check" @click="deleteCompanyReport" />
		</template>
	</Dialog>
</template>

<script lang="ts">
	import { defineComponent } from "vue";
	import { useRoute } from "vue-router";
	import store from "@/store";

	import consoGroupApi from "@/api/consogroup-api";
	import currencyApi from "@/api/currency-api";
	import purposeApi from "@/api/purpose-api";
	import companyApi from "@/api/company-api";
	import companyReportApi from "@/api/companyreport-api";
	import companyReportDetailApi from "@/api/companyreportdetail-api";
	import companyReportSheetApi from "@/api/companyreportsheet-api";
	import companyReportSheetTemplateApi from "@/api/companyreportsheettemplate-api";
	import journalApi from "@/api/journal-api";

	import roleMixin from "@/mixin/role";
	import statusMixin from "@/mixin/status";
	import dateUtilsMixin from "@/mixin/utils/date-utils";
	import formulaMixin from "@/mixin/formula";

	import TheHeader from "@/components/TheHeader.vue";
	import TheFooter from "@/components/TheFooter.vue";
	import TheSidebar from "@/components/TheSidebar.vue";
	import ThePageHeader from "@/components/ThePageHeader.vue";
	import ThePageLoading from "@/components/ThePageLoading.vue";
	import TheLoading from "@/components/TheLoading.vue";
	import ThePageError from "@/components/ThePageError.vue";
	import TheSheetsDialog from "@/components/TheSheetsDialog.vue";
	
	import useVuelidate from "@vuelidate/core";
	import { required } from "@vuelidate/validators";
	import { FilterMatchMode } from "primevue/api";

	export default defineComponent({
		mixins: [roleMixin, statusMixin, dateUtilsMixin, formulaMixin],
		components: {
			TheHeader,
			TheFooter,
			TheSidebar,
			ThePageHeader,
			ThePageLoading,
			TheLoading,
			ThePageError,
			TheSheetsDialog,
		},
		data() {
			return {
				pageError: (store.getters.error == undefined ? '' : store.getters.error),
				identifier: useRoute().params.id,
				companyReport: {identifier: null, fileId: null, consoGroup: {identifier: null as any, name: ''}, balanceSheetDate: null as any, currency: {identifier: null, code: ''}, purpose: {identifier: null, name: ''}, isConsolidated: false, id: 0.0, createdUserId: '', createdBy: '', createdDate: '', submissionBy: '', submissionDate: '', status: '', companyReportDetails: [] as any[], isClosed: false, templateVersion: null},
				companyReportSheets: [] as any[],
				companies: [] as any[],
				consoGroups: [] as any[],
				currencies: [] as any[],
				isConsoGroupLoading: false,
				isPageLoading: false,
				isLoading: false,
				isDeleting: false,
				isImporting: false,
				isExporting: false,
				isCalculating: false,
				isCWKLoaded: false,
				loadedInFileId: '',
				dialog: {identifier: null, consoGroupName: null as any, balanceSheetDate: null as any, currencyCode: null as any, id: 0.0, templateIndex: 0, status: '', visible: false, loading: false, isUnsaved: false, companyReportSheets: null as any},
				isShowUnsavedConfirmation: false,
				isDeleteConfirmation: false,
				isEmptyCWK: true,
			};
		},
		watch: {
			filterLegalGroup(newValue: any) {
				if (this.identifier == null) {
					this.isConsoGroupLoading = true;
					consoGroupApi.consoGroupList({value: newValue})
						.then(response => {
							this.consoGroups = response.data.listSet;
							this.isConsoGroupLoading = false;
						})
						.catch(error => {
							this.$toast.add({severity: "error", summary: "Error", detail: error, life: 6000});
							this.isConsoGroupLoading = false;
						})
					companyApi.companyList({isRpk: true, isSheetDialog: true}, this.filterLegalGroup == null ? null : this.filterLegalGroup.identifier)
						.then(response => {
							this.companies = response.data.listSet;
						})
						.catch(error => {
							this.$toast.add({severity: "error", summary: "Error", detail: error, life: 6000});
						})
				}
			},
		},
		computed: {
			filterLegalGroup() {
				return (store.getters.getFilterLegalGroupModel != null ? store.getters.getFilterLegalGroupModel : null);
			},
			staleChildren() {
				// Children (loaded RPK/CWK/Journal) whose load date (statusDate) is before their source
				// report's finalise date (referenceSubmissionDate) - the source was finalised after being
				// loaded, so the loaded data may be outdated.
				const details = (this.companyReport && this.companyReport.companyReportDetails) ? this.companyReport.companyReportDetails : [];
				return details.filter((detail: any) => {
					if (detail == null || detail.lastModifiedDate == null || detail.referenceSubmissionDate == null || detail.referenceSubmissionDate == '') {
						return false;
					}
					const loadDate = new Date(detail.lastModifiedDate.toString().replace(' ', 'T'));
					const sourceFinaliseDate = new Date(detail.referenceSubmissionDate.toString().replace(' ', 'T'));
					return loadDate < sourceFinaliseDate;
				});
			},
		},
		mounted: function () {
			if (this.pageError == '') {
				this.isPageLoading = true;

				let r1 = consoGroupApi.consoGroupList({value: this.filterLegalGroup});

				let r2 = currencyApi.currencyList({});

				let r3 = null;

				let r4 = companyApi.companyList({isRpk: true, isSheetDialog: true}, this.filterLegalGroup == null ? null : this.filterLegalGroup.identifier)

				let r5 = null;

				if (this.identifier != null) {
					r3 = companyReportApi.companyReportView(this.identifier, 'cwk')
						.catch(error => {
							this.pageError = error;
							this.isPageLoading = false;
						});

					r5 = companyReportApi.companyReportCheckLoaded(this.identifier, 'cwk');
				}

				Promise.all([r1, r2, r3, r4, r5])
					.then((values: any) => {
						if (values != null) {
							for (var i = 0; i < values.length; i++) {
								if (values[i] != null) {
									if (values[i].success) {
										if (values[i].data != null) {
											if (i == 0) {
												this.consoGroups = values[i].data.listSet;
											}
											
											else if (i == 1) {
												this.currencies = values[i].data.listSet;

												if (this.identifier == null) {
													this.filterCurrencyByDefaultCode('MYR');
												}
											}

											else if (i == 2) {
												this.companyReport = values[i].data.companyReport;
												if (this.companyReport != null) {	
													if (this.companyReport.balanceSheetDate != null){
														this.companyReport.balanceSheetDate = this.formatToDate(this.companyReport.balanceSheetDate);
													}
													if (this.companyReport.submissionDate != null && this.companyReport.submissionDate != '') {
														this.companyReport.submissionDate = this.formatToDateTime(this.companyReport.submissionDate);
													}
													if (this.companyReport.purpose == null) {
														this.companyReport.purpose = {'identifier': null, 'name': ""};
													}
												}
											}
											
											else if (i == 3) {
												this.companies = values[i].data.listSet;
											}

											else if (i == 4) {
												this.isCWKLoaded = values[i].data.isLoaded;
												this.loadedInFileId = values[i].data.loadedIn;
											}
										}
									}
								}
							}
							this.isPageLoading = false;
						}
					})
					.catch(error => {
						this.isPageLoading = false;
						this.$toast.add({severity: "error", summary: "Error", detail: error, life: 6000});
					});
			}
		},
		methods: {
			save() {
				this.isLoading = true;

				if (this.companyReport.balanceSheetDate != null && (this.companyReport.balanceSheetDate instanceof Date)) {
					this.companyReport.balanceSheetDate = this.formatToDate(this.companyReport.balanceSheetDate);
				}
				
				companyReportApi.companyReportSave({companyReport: this.companyReport}, 'cwk')
					.then(response => {
						store.getters.getCached.page = null;
						this.isLoading = false;
						// After a successful create, go to the new report's edit details page (not the list).
						this.$router.push("/companyreport/cwk/view/" + response.data.companyReport.identifier);
					})
					.catch(error => {
						this.isLoading = false;
						this.$toast.add({severity: "error", summary: "Error", detail: error, life: 6000});
					});
			},
			submit() {
				this.$confirm.require({
					header: 'Confirmation',
					message: 'Are you sure you want to finalise this company report?',
					icon: 'pi pi-exclamation-triangle',
					accept: () => {
						this.isLoading = true;

						companyReportApi.companyReportSubmit({companyReport: this.companyReport}, 'cwk')
							.then(response => {
								store.getters.getCached.page = null;
								this.isLoading = false;
								// Stay on the details page and refresh it to reflect the finalised status.
								this.$router.go(0);
							})
							.catch(error => {
								this.isLoading = false;
								this.$toast.add({severity: "error", summary: "Error", detail: error, life: 6000});
							});
					}
				});
			},
			unfinalise() {
				this.$confirm.require({
					header: 'Confirmation',
					message: 'Are you sure you want to unfinalise this company report?',
					icon: 'pi pi-exclamation-triangle',
					accept: () => {
						this.isLoading = true;
						this.isExporting = true;

						companyReportApi.companyReportExport({identifier: this.identifier, templateIndex: 1, actionType: "backup", backupAction: "UNF"}, 'cwk')
							.then(response => {
								this.$toast.add({severity: "success", summary: "Success", detail: "Your backup will download shortly.", life: 6000});
								this.isExporting = false;

								companyReportApi.companyReportUnfinalise({companyReport: this.companyReport}, 'cwk')
								.then(response => {
									store.getters.getCached.page = null;
									this.isLoading = false;
									// Stay on the details page and refresh it to reflect the unfinalised status.
									this.$router.go(0);
								})
								.catch(error => {
									this.isLoading = false;
									this.$toast.add({severity: "error", summary: "Error", detail: error, life: 6000});
								});
							})
							.catch(error => {
								this.isExporting = false;
								
								this.$toast.add({severity: "error", summary: "Error", detail: error, life: 6000});
						});

							

					}
				});
			},
			openDeleteDialog() {
				this.isEmptyCWK = true;
				this.companyReport.companyReportDetails.forEach((detail, index) => {
					if (detail.status == "Completed" || detail.status == "Pending Translated") {
						this.isEmptyCWK = false;
					}
				});
				this.isDeleteConfirmation = true;
			},
			deleteCompanyReport() {
				this.isDeleting = true;
				this.isExporting = true;
				
				companyReportApi.companyReportExport({identifier: this.identifier, templateIndex: 1, actionType: "backup", backupAction: "DEL"}, 'cwk')
					.then(response => {
                        this.$toast.add({severity: "success", summary: "Success", detail: "Your backup will download shortly.", life: 6000});
						this.isExporting = false;
						companyReportApi.companyReportDelete({companyReport: this.companyReport, identifier: this.identifier}, 'cwk')
							.then((response: any) => {
								store.getters.getCached.page = null;
								this.isDeleting = false;
								this.isDeleteConfirmation = false;
								this.$toast.add({severity: "success", summary: "Success", detail: response.message, life: 6000});
								this.$router.push("/companyreport/cwk");
							})
							.catch(error => {
								this.isDeleting = false;
								this.isDeleteConfirmation = false;
								this.$toast.add({severity: "error", summary: "Error", detail: error, life: 6000});
							});
					})
					.catch(error => {
						this.isDeleting = false;
						this.isExporting = false;
						this.$toast.add({severity: "error", summary: "Error", detail: error, life: 6000});
					});
			},
			importFile(file: any) {
				this.isExporting = true;
				this.isImporting = true;
				
				companyReportApi.companyReportExport({identifier: this.identifier, templateIndex: 1, actionType: "backup", backupAction: "IMP"}, 'cwk')
					.then(response => {
                        this.$toast.add({severity: "success", summary: "Success", detail: "Your backup will download shortly.", life: 6000});
						this.isExporting = false;

						var formData = new FormData();
						formData.append('file', file[0]);

						companyReportApi.companyReportImport(formData, this.identifier, 'cwk')
							.then((response: any) => {
								this.isImporting = false;
								this.$toast.add({severity: "success", summary: "Success", detail: response.message, life: 6000});
								this.calculate(1);
							})
							.catch(error => {
								this.isImporting = false;
								this.$toast.add({severity: "error", summary: "Error", detail: error, life: 6000});
							});
					})
					.catch(error => {
						this.isImporting = false;
						this.isExporting = false;
						
						this.$toast.add({severity: "error", summary: "Error", detail: error, life: 6000});
					});
			},
			exportFile() {
				this.isExporting = true;
				companyReportApi.companyReportExport({identifier: this.identifier, templateIndex: 1, actionType: "manual"}, 'cwk')
					.then(response => {
						this.isExporting = false;
					})
					.catch(error => {
						this.isExporting = false;
						this.$toast.add({severity: "error", summary: "Error", detail: error, life: 6000});
					});
			},
			cancel() {
				this.$router.push("/companyreport/cwk");
			},
			filterCurrencyByDefaultCode: function (code: any) {
				var currencies = this.currencies.filter(function (currency: any) {
					if (currency.code == code) {
						return currency;
					}
				});
				if (currencies != null && currencies.length > 0) {
					return this.companyReport.currency.identifier = currencies[0].identifier;
				}
			},
			filterCurrencyCodeByValue: function (value: any) {
				var currencies = this.currencies.filter(function (currency: any) {
					if (currency.identifier == value) {
						return currency;
					}
				});
				if (currencies != null && currencies.length > 0) {
					return currencies[0].code;
				}
				return null;
			},
			filterCurrencyNameByValue: function (value: any) {
				var currencies = this.currencies.filter(function (currency: any) {
					if (currency.identifier == value) {
						return currency;
					}
				});
				if (currencies != null && currencies.length > 0) {
					return currencies[0].name;
				}
				return null;
			},
			showDetailDialog() {
				this.$router.push("/companyreport/cwk/view/" + this.companyReport.identifier + "/configuration");
			},
			sheets(templateIndex: any, getUnsaved: any, companyReportSheets: any) {
				getUnsaved ? this.dialog.isUnsaved = true : this.dialog.isUnsaved = false;
				this.isShowUnsavedConfirmation = false;

				this.dialog.identifier = this.companyReport.identifier;
				this.dialog.consoGroupName = this.companyReport.consoGroup.name;
				this.dialog.balanceSheetDate = this.companyReport.balanceSheetDate;
				this.dialog.currencyCode = this.companyReport.currency.code;
				this.dialog.id = this.companyReport.id;
				this.dialog.templateIndex = templateIndex;
				this.dialog.isUnsaved ? this.dialog.id = this.unsavedId : this.dialog.id = this.companyReport.id;
				this.dialog.status = this.companyReport.status;
				this.dialog.companyReportSheets = companyReportSheets;
				this.dialog.visible = true;

				document.body.classList.add("dialog-open");
			},
			updateSheets(companyReportSheets: any, isCloseDialog: any, isNearestThousand:any) {
				this.dialog.loading = true;
				this.isImporting = true;

				let rs = [] as any[];

				companyReportSheets.forEach((companyReportSheet: any, index: any) => {
					if (companyReportSheet.sheetError == '') {
						let r = companyReportSheetApi.companyReportSheetUpdate({identifier: this.identifier, companyReportSheet: {identifier: companyReportSheet.identifier, sheet: companyReportSheet.sheet, content: {template: companyReportSheet.template}}}, this.dialog.templateIndex)
							.catch(error => {
								this.$toast.add({severity: "error", summary: "Error", detail: error, life: 6000});
							});
						rs.push(r);
					}
				});

				if (!this.isCalculating) {
					let r1 = companyReportApi.companyReportUpdateId({companyReport: this.companyReport}, 'cwk', this.dialog.templateIndex);
					rs.push(r1);
				}
				
				Promise.all(rs)
					.then((values: any) => {
						if (values != null) {
							for (var i = 0; i < values.length; i++) {
								if (values[i] != null) {
									if (values[i].success) {
										if (values[i].data != null) {
											if (i == values.length - 1 && !this.isCalculating) {
												this.companyReport.id = values[i].data.companyReport.id;
												this.dialog.id = this.companyReport.id;
											}
										}
									}
								}
							}
						}
						this.dialog.loading = false;
						this.isImporting = false;

						if (isCloseDialog) {
							this.closeDialog(true, null, null, null, null);
						}
					})
					.catch(error => {
						this.dialog.loading = false;
						this.isImporting = false;
						this.$toast.add({severity: "error", summary: "Error", detail: error, life: 6000});
					});
			},
			updateSheetCached(companyReportSheet: any, pageIndex: any, scrollTop: any, scrollLeft: any, lastAccessedCell: any) {
				var companyReportSheetCached = {identifier: null, sheet: {identifier: null}, content: {template: null}, pageIndex: 0, scrollDetail: {scrollTop: 0, scrollLeft: 0}, lastAccessedCell: null};
				companyReportSheetCached.identifier = companyReportSheet.identifier;
				companyReportSheetCached.sheet = companyReportSheet.sheet;
				companyReportSheetCached.content.template = companyReportSheet.template;
				companyReportSheetCached.pageIndex = pageIndex;
				companyReportSheetCached.scrollDetail.scrollTop = scrollTop;
				companyReportSheetCached.scrollDetail.scrollLeft = scrollLeft;
				companyReportSheetCached.lastAccessedCell = lastAccessedCell;

				companyReportSheetApi.companyReportSheetUpdateCached({identifier: this.identifier, companyReportSheet: companyReportSheetCached}, this.dialog.templateIndex)
					.then(response => {
						//
					})
					.catch(error => {
						//
					});
			},
			deleteSheetCached(companyReportSheet: any, pageIndex: any, scrollTop: any, scrollLeft: any, lastAccessedCell: any, isCloseDialog: any) {
				this.dialog.loading = true;

				var companyReportSheetCached = {identifier: null, pageIndex: 0, scrollDetail: {scrollTop: 0, scrollLeft: 0}, lastAccessedCell: null};
				companyReportSheetCached.identifier = companyReportSheet.identifier;
				companyReportSheetCached.pageIndex = pageIndex;
				companyReportSheetCached.scrollDetail.scrollTop = scrollTop;
				companyReportSheetCached.scrollDetail.scrollLeft = scrollLeft;
				companyReportSheetCached.lastAccessedCell = lastAccessedCell;

				companyReportSheetApi.companyReportSheetDeleteCached({identifier: this.identifier, companyReportSheet: companyReportSheetCached}, this.dialog.templateIndex)
					.then(response => {
						this.dialog.loading = false;

						if (isCloseDialog) {
							this.closeDialog(true, null, null, null, null);
						}
					})
					.catch(error => {
						this.dialog.loading = false;
						this.$toast.add({severity: "error", summary: "Error", detail: error, life: 6000});
					});
			},
			closeDialog(hasCached: any, pageIndex: any, scrollTop: any, scrollLeft: any, lastAccessedCell: any) {
				if (!hasCached) {
					var lastAccessedDetail = {pageIndex: 0, scrollDetail: {scrollTop: 0, scrollLeft: 0}, lastAccessedCell: null};
					lastAccessedDetail.pageIndex = pageIndex;
					lastAccessedDetail.scrollDetail.scrollTop = scrollTop;
					lastAccessedDetail.scrollDetail.scrollLeft = scrollLeft;
					lastAccessedDetail.lastAccessedCell = lastAccessedCell;

					companyReportApi.companyReportLastAccess({identifier: this.identifier, lastAccessedDetail: lastAccessedDetail}, 'cwk', this.dialog.templateIndex)
						.then(response => {
							//
						})
						.catch(error => {
							//
						});
				}
				this.dialog.visible = false;
				document.body.classList.remove("dialog-open");
			},
			calculate(templateIndex: any) {
				this.isCalculating = true;
				
				companyReportSheetApi.companyReportSheetViewByCompanyReportId(this.identifier, 'cwk', templateIndex)
					.then(response => {
						this.companyReportSheets = response.data.listSet;
						
						let r = [] as any[];
						this.companyReportSheets.forEach((companyReportSheet: any, index: any) => {
							companyReportSheet.sheetError = '';
							r.push(companyReportSheetTemplateApi.companyReportSheetTemplateViewByCompanyReportSheet(templateIndex, companyReportSheet.identifier, {identifier: this.identifier, isUnsaved: false})
								.catch(error => {
									companyReportSheet.sheetError = error;
								}));
						});
						
						Promise.all(r)
							.then((values: any) => {
								if (values != null) {
									for (var i = 0; i < values.length; i++) {
										if (values[i] != null && values[i].data != null) {
											this.companyReportSheets[i].template = values[i].data.content.template;
											
											this.companyReportSheets[i].navigateChilds = [];
											if (values[i].data.function != null && values[i].data.function.navigateChilds != null) {
												this.companyReportSheets[i].navigateChilds = values[i].data.function.navigateChilds;
											}
											
											this.setComponents(this.companyReportSheets, i, false);
										}
									}
									
									for (var j = 0; j < values.length; j++) {
										if (values[j] != null && values[j].data != null) {
											this.setValues(this.companyReportSheets, j, 'cwk', false);
										}
									}
									
									if (templateIndex == 1) {
										this.isCalculating = false;										
										this.dialog.templateIndex = 1;
										this.updateSheets(this.companyReportSheets, false, false);
									}
								}
							})
							.catch(error => {
								this.isCalculating = false;
							})
					})
					.catch((error: any) => {
						this.$toast.add({severity: "error", summary: "Error", detail: error, life: 6000});
						this.isCalculating = false;
					})
			},
			onConsoGroupChange() {
				if (this.companyReport.consoGroup.identifier != null) {
					var consoGroups = this.consoGroups.filter((consoGroup: any) => consoGroup.identifier == this.companyReport.consoGroup.identifier);
					var code = consoGroups[0].name.split('-')[1];
					var companies = this.companies.filter((company: any) => company.code == code);
					if (companies != null && companies.length > 0 && companies[0].currency != null) {
						this.filterCurrencyByDefaultCode(companies[0].currency);
					}

					else {
						this.filterCurrencyByDefaultCode('MYR');
					}

				} else {
					this.filterCurrencyByDefaultCode('MYR');
				}
			}

		},
		setup() {
			return {v$: useVuelidate()};
		},
		validations() {
			return {
				companyReport: {
					consoGroup: {
						identifier: {
							required
						},
					},
					balanceSheetDate: {
						required
					},
					currency: {
						identifier: {
							required
						},
					},
					isClosed: {
						required
					},
				}
			};
		},
	});
</script>
